import { render, staticRenderFns } from "./2fa.vue?vue&type=template&id=7b3654bb&scoped=true&"
import script from "./2fa.vue?vue&type=script&lang=js&"
export * from "./2fa.vue?vue&type=script&lang=js&"
import style0 from "./2fa.vue?vue&type=style&index=0&id=7b3654bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3654bb",
  null
  
)

export default component.exports